var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "event-detail clearfix", class: [_vm.theme] },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "loading-wrapper" },
            [_c("loading", { attrs: { loading: _vm.loading } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fadeIn" } }, [
        _vm.previewEventFlyer
          ? _c(
              "div",
              {
                staticClass: "event-image-preview",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.hidePreviewEventFlyer($event)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "preview-close",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.hidePreviewEventFlyer($event)
                      },
                    },
                  },
                  [_c("i", { staticClass: "icon ion-close" })]
                ),
                _vm._v(" "),
                _c("img", {
                  staticClass: "img",
                  attrs: { src: _vm.getImageUrl() },
                  on: { load: [function ($event) {}, _vm.imgLoaded] },
                }),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.loading && !_vm.eventNotFound
        ? _c("div", { staticClass: "event-detail-content clearfix" }, [
            _c("div", { staticClass: "left-panel" }, [
              _c("div", { staticClass: "event-name" }, [
                _c("h1", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.event.name)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "event-header clearfix" }, [
                _c("div", { staticClass: "event-image left-col" }, [
                  _c(
                    "a",
                    {
                      staticClass: "img-wrapper",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.showPreviewEventFlyer($event)
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: { src: _vm.getImageUrl() },
                        on: { load: [function ($event) {}, _vm.imgLoaded] },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "expand-icon",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.showPreviewEventFlyer($event)
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon ion-arrow-expand" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "event-name-info right-col" }, [
                  _c("div", { staticClass: "name-section" }, [
                    _c("div", { staticClass: "name-header clearfix" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "icon block pull-left",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "40",
                            height: "40",
                            viewBox: "0 0 40 40",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "#5F6161",
                              "fill-rule": "evenodd",
                              d: "M14.4 9.571h11.2V6h2.8v3.571H34V31H6V9.571h5.6V6h2.8v3.571zm-5.6 7.143v11.429h22.4V16.714H8.8z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("h2", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm._f("eventDate")(_vm.event))),
                      ]),
                    ]),
                    _vm._v(" "),
                    !_vm.eventHasPassed
                      ? _c("div", { staticClass: "date-sub" }, [
                          _c("p", { staticClass: "time" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm._f("formatUTCDate")(
                                    _vm.event.dateStart,
                                    "h:mmA"
                                  )
                                ) +
                                "\n                "
                            ),
                            _vm.event.dateEnd
                              ? _c("span", [
                                  _vm._v(
                                    "- " +
                                      _vm._s(
                                        _vm._f("formatUTCDate")(
                                          _vm.event.dateEnd,
                                          "h:mmA"
                                        )
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "door" }, [
                            _vm._v(
                              "Doors open at " +
                                _vm._s(
                                  _vm._f("formatUTCDate")(
                                    _vm.event.dateStart,
                                    "h:mmA"
                                  )
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.event.details && _vm.event.details.minAge > 0
                            ? _c("p", { staticClass: "min-age" }, [
                                _vm._v(
                                  "Age: " +
                                    _vm._s(_vm.event.details.minAge) +
                                    "+"
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "name-section" }, [
                    _c("div", { staticClass: "name-header clearfix" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "icon block pull-left",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "40",
                            height: "40",
                            viewBox: "0 0 40 40",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "#5F6161",
                              "fill-rule": "evenodd",
                              d: "M20 36.158S8 24.628 8 16C8 9.373 13.373 4 20 4s12 5.373 12 12c0 8.627-12 20.158-12 20.158zM20 21a5 5 0 1 0 0-10 5 5 0 0 0 0 10z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("h2", { staticClass: "text" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#", target: "_blank" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.goToMapsUrl($event)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.event.venue.name) + " ")]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.event.description
                ? _c(
                    "div",
                    { staticClass: "event-description" },
                    [
                      _c("read-more", {
                        attrs: {
                          "more-str": "read more",
                          text: _vm.event.description,
                          link: "#",
                          "less-str": "read less",
                          "max-chars": 600,
                        },
                        on: { updated: _vm.onUpdated },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "event-content" }, [
                _vm.event.isMapWidgetEnabled
                  ? _c(
                      "div",
                      { staticClass: "event-map-widget" },
                      [
                        _c("inventory-map", {
                          ref: "inventoryMap",
                          on: {
                            floorplanLoaded: _vm.onFloorplanLoaded,
                            inventorySectionClicked:
                              _vm.onInventorySectionClicked,
                            updated: _vm.onInventoryMapUpdated,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.event.details && _vm.event.details.soundcloud
                  ? _c("div", { staticClass: "event-soundcloud" }, [
                      _c("iframe", {
                        attrs: {
                          width: "100%",
                          height: "166",
                          scrolling: "no",
                          frameborder: "no",
                          src: _vm.soundcloudUrl,
                        },
                      }),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right-panel" },
              [
                _vm.eventHasPassed
                  ? _c("div", { staticClass: "event-passed" }, [
                      _vm._v("This event has already passed."),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.event.inventoryNote && !_vm.eventHasPassed
                  ? _c("div", {
                      staticClass: "inventory-note",
                      domProps: { innerHTML: _vm._s(_vm.event.inventoryNote) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.venue && !_vm.eventHasPassed
                  ? _c("inventory-list", {
                      ref: "inventoryList",
                      attrs: {
                        "event-id": _vm.event.id,
                        "selling-link": _vm.event.externalSellingLink,
                        "enable-reservation-request":
                          _vm.event.isReservationEnabled,
                        "enable-guestlist": _vm.event.isGuestListEnabled,
                      },
                      on: {
                        inventorySelected: _vm.scrollWindow,
                        updated: _vm.onInventoryListUpdated,
                        inventoryMouseover: _vm.onInventoryMouseover,
                        inventoryMouseleave: _vm.onInventoryMouseleave,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventNotFound
        ? _c("div", { staticClass: "event-detail-content not-found" }, [
            _c("div", { staticClass: "alert alert-info" }, [
              _vm._v("Sorry, we could not find the event you're looking for."),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/EventDetail/template.html?vue&type=template&id=12ec2e4e&
// module id = 1047
// module chunks = 0